export enum RecoveryMethodEnum {
    PrimaryEmail = 'PrimaryEmail',
    RecoveryEmail = 'RecoveryEmail',
    Phone = 'Phone',
}
